import { ActualFundType } from "@constants/funds-data";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:8000";
const fetchFundsQuery = `${API_URL}/funds`;

const options: RequestInit = {
  method: "GET",
  mode: "cors",
  headers: {
    "Content-Type": "application/json",
  },
};

export const fetchFundsList = async (): Promise<ActualFundType[]> => {
  try {
    const res = await fetch(fetchFundsQuery, options);
    const list = await res.json();

    return list.funds;
  } catch (e) {
    console.error("API fetchFunds ERROR ::", e);
    return [];
  }
};
